var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 495 180",
    width: 495,
    height: 180,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ch-logo-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #009099 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m28 179.8c-15.6 0-28-11.2-28-30.4 0-19.8 13.1-31.4 28.9-31.4 10.4 0 16.4 3.9 17.4 4.9l-2.6 4.2c-0.6-0.4-6-3.8-14.4-3.8-12.9 0-23.6 9.5-23.6 25.4 0 15.7 8.9 25.8 22.9 25.8 9 0 15.3-4.4 15.6-4.6l2.7 4.1c-0.5 0.8-7.6 5.8-18.9 5.8zm51.9-4.2c-0.4 0.2-6.1 4.1-13.7 4.1-8.2 0-13.8-5.3-13.8-13 0-13.6 17.3-14 24.7-14h2.2v-1.7c0-4-0.2-7-2.1-9-1.3-1.3-3.7-2.5-8.1-2.5-6.6 0-11.2 3-11.9 3.4l-2.2-3.8c0.4-0.4 5.9-4.4 14.7-4.4 5.4 0 9.1 1.6 11.6 4.1 2.9 2.9 3.4 5.8 3.4 12.3v27.6h-4.8zm-2.8-18.6c-11 0-19 2.5-19 9.7 0 4.3 2.8 8.2 9.5 8.2 5.5 0 10.8-2.9 12-3.5v-14.4c-1.2 0-2.5 0-2.5 0zm18.3 21.8v-64.3h5.4v64.3zm35.4 0h-6.3l-16.7-42.9h5.9l14.2 37.2 14.2-37.2h5.5zm55.1-20.4h-30.7c0 9.5 5.1 16.3 14.7 16.3 7.1 0 11.9-3.2 12.4-3.5l2.4 4.1c-0.2 0.3-6.5 4.4-15.3 4.4-12.5 0-19.8-9.1-19.8-22.1 0-13.8 7.7-22.8 19.6-22.8 9.9 0 16.9 7.5 16.9 20.7-0.1 0.5-0.2 2-0.2 2.9zm-16.6-19c-7.4 0-13.4 5.5-13.9 14.5h25.3c-0.1-6.4-3.1-14.5-11.4-14.5zm47.6 0.5c-0.6-0.1-1.8-0.3-3.5-0.3-9.1 0-12.7 7.1-13 7.5v31.6h-5.4v-42.9h5.1v5.6c0.4-0.5 4.8-6.8 13.6-6.8 3.2 0 4.2 0.6 4.5 0.7zm24.7 39.8c-3.9 0-6.8-1-8.8-3-2.5-2.5-2.5-5.9-2.5-11.1v-25.4h-7.5v-4.4h7.5v-12.1h5.4v12.1h13.8v4.4h-13.8v24.3c0 5.9-0.4 10.4 6.7 10.4 3.3 0 5.9-1.2 6.3-1.3l1.4 4.1c-0.7 0.3-3.6 2-8.5 2zm52.2-0.9v-26.8h-24.6v26.8h-10.4v-59.6h10.4v24.2h24.6v-24.2h10.4v59.6zm57.6-18.9h-29.6c0 5.3 3.3 12.1 12.4 12.1 6.1 0 10.7-2.7 12-3.3l3.4 6.4c-0.4 0.3-6.7 4.7-16.2 4.7-13.7 0-21.3-9.7-21.3-22.6 0-13.7 8.3-23.3 20.6-23.3 11.9 0 18.8 8.6 18.8 22.5 0.1 1.5-0.1 2.8-0.1 3.5zm-18.4-18.5c-6.1 0-10.4 4.6-11.2 11.2h20.4c0.1-3.7-1.4-11.2-9.2-11.2zm50.7 37.4v-3.2c-0.6 0.4-5.7 4.1-12.9 4.1-8.6 0-14-5.6-14-13.8 0-14.9 18.5-15.3 24.6-15.3h1.6v-1.7c0-2.8-0.3-4.3-1.4-5.4-1.3-1.2-3-2-7.1-2-5.9 0-11.2 3-11.8 3.4l-3.4-6.3c0.7-0.6 6.3-4.7 16-4.7 6.5 0 10.4 1.5 13.6 4.6 3.4 3.4 3.4 7.7 3.4 13.5v26.8zm-2.8-21.2c-6.2 0-11.1 0.9-13.6 3.4-1.2 1.2-1.7 2.6-1.7 4.5 0 4.5 3.5 6.6 7.7 6.6 5.1 0 8.9-2.6 9.6-2.9v-11.6c-1 0-2 0-2 0zm21.9 21.2v-64.6h9.8v64.6zm37.9 1.1c-3.9 0-7.9-1.1-10.5-3.7-3.5-3.5-3.3-7.8-3.3-13.4v-19.6h-7.6v-8h7.6v-12.2h9.8v12.2h12.9v8h-12.9v20.5c0 3.9 0.2 7.9 5.9 7.9 3.1 0 5.3-1 5.8-1.2l2.5 6.9c-0.5 0.3-4.2 2.6-10.2 2.6zm43.9-24.9c0-5.6-0.1-8.7-2.1-10.7-0.8-0.8-2.7-1.9-5.4-1.9-4.9 0-9.1 2.8-9.7 3.2v33.2h-9.8v-64.6h9.8v23.4c0 0 5.4-3.7 11.7-3.7 5.4 0 8.8 2 10.9 4 4.6 4.6 4.5 10.1 4.5 16.4v24.4h-9.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m242.1 64.4v4.4c0 2.2-1.2 3.2-3.4 3.2h-10.4c-2.3 0-3.4-1.1-3.4-3.2v-48.1c0-2.1 1.2-3.2 3.4-3.2h10.4c2.3 0 3.4 1.2 3.4 3.2v4.4c0.4-8.8 5.1-16.5 12.1-20.9-4.1-2.6-8.9-4.1-14-4.1h-14.1c-14.4 0-26.1 11.8-26.1 26.1v37.1c0 14.4 11.8 26.1 26.1 26.1h14.1c5.1 0 9.9-1.5 14-4.1-7-4.4-11.8-12.1-12.1-20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m282.2 0.1h-14.1c-5.1 0-9.9 1.5-14 4.1 6.5 4.2 11.1 11.2 12 19.3v-2.8c0-2.1 1.2-3.2 3.5-3.2h10.6c2.3 0 3.4 1.2 3.4 3.2v48.2c0 2.2-1.2 3.2-3.4 3.2h-10.6c-2.3 0-3.5-1.1-3.5-3.2v-2.8c-0.9 8.1-5.4 15.1-12 19.3 4.1 2.6 8.9 4.1 14 4.1h14.1c14.4 0 26.1-11.8 26.1-26.1v-37.1c0.1-14.4-11.7-26.2-26.1-26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m254.2 4.2c6.5 4.2 11.1 11.2 12 19.3v14.4h-24.1v-12.8c0.3-8.7 5.1-16.4 12.1-20.9zm0 81.1c-7-4.4-11.7-12.1-12.1-20.9v-11.9h24.1v13.6c-0.9 8.1-5.5 15.1-12 19.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.9 152.2q-0.1 0-0.1-0.1 0-0.1 0.1-0.1 0.1 0 0.1 0.1 0 0.1-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.9 152.2v0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.9 152.2l-0.1 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.8 152.3l-0.1-0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.8 152.5l0.2 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m341.7 152.6l0.2-0.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChLogo);
export default __webpack_public_path__ + "static/media/ch-logo.09a94329de4a1a000d130fcdbe803893.svg";
export { ForwardRef as ReactComponent };